/* Atelier — ritual tabs: WAI-ARIA tabs (click, arrow keys, Home/End) with one panel per tab. */
if (!customElements.get('atelier-tabs')) {
  customElements.define(
    'atelier-tabs',
    class AtelierTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab || !this.contains(tab)) return;
          this.select(tab);
        });
        this.addEventListener('keydown', (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab) return;
          const tabs = this.tabs();
          const i = tabs.indexOf(tab);
          let next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          event.preventDefault();
          this.select(next);
          next.focus();
        });
        // Theme editor: show the tab whose block is selected.
        this.addEventListener('shopify:block:select', (event) => {
          const tab = event.target.closest && event.target.closest('[role="tab"]');
          if (tab) this.select(tab);
        });
      }

      tabs() {
        return Array.from(this.querySelectorAll('[role="tab"]'));
      }

      select(tab) {
        this.tabs().forEach((item) => {
          const on = item === tab;
          item.setAttribute('aria-selected', on ? 'true' : 'false');
          item.setAttribute('tabindex', on ? '0' : '-1');
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (tab.scrollIntoView && tab.parentElement && tab.parentElement.scrollWidth > tab.parentElement.clientWidth) {
          const list = tab.parentElement;
          const left = tab.offsetLeft - list.offsetLeft;
          if (left < list.scrollLeft || left + tab.offsetWidth > list.scrollLeft + list.clientWidth) {
            list.scrollTo({ left: Math.max(0, left - 24), behavior: 'smooth' });
          }
        }
      }
    }
  );
}
